export enum FieldGroupTypeEnum {
  None = 0,
  ProfileFields = 1,
  MembershipFields = 2,
  PurchaseItemFields = 3,
  RelatedProfileFields = 4,
  AdditionalInfoFields = 5,
  MainContactFields = 6,
  SocialMedia = 7,
  Listing = 8,
  CustomField = 9,
  ProfileAddress = 11,
  HBAProfileData = 12,
  UploadFile = 16,
}
